import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {AffiliateUser} from '../../models/partner/affiliate-user';

@Injectable({
  providedIn: 'root'
})
export class AffiliateUserService extends AbstractModelService<AffiliateUser> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/affiliate-user', AffiliateUser);
  }
}
